<div fxLayout="column">
    <div *ngIf="!isLoading" fxLayout="row" fxLayoutAlign="center center center" style="height: 100px;border-bottom:1px solid lightgray;">

        <div fxFlex="5">&nbsp;</div>

        <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">Δήλωση</div>
        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="start center center">
            Δραστηριότητα
        </div>
        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Συμπλήρωσαν
        </div>
        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Ακύρωσαν
        </div>
        <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif" fxLayoutAlign="center center center">Σε αναμονή
        </div>
        <div fxFlex="5"></div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center center">
        <div fxLayoutAlign="center center center"
             style="height: 100px;border-bottom:1px solid lightgray;" fxFlex="100"
             *ngFor="let reportAffirmation of reports">

            <div fxFlex="5">
                <mat-icon>bookmark</mat-icon>
            </div>

            <div fxFlex="30" style="font-family: 'Century Gothic', sans-serif"
                 fxLayoutAlign="start center center">{{reportAffirmation.formTitle}}</div>
            <div fxFlex="15" style="font-family: 'Century Gothic', sans-serif"
                 fxLayoutAlign="start center center">{{reportAffirmation.activityDescription}}</div>
            <div fxLayout="column" fxFlex="15">
                <div fxLayout="row"
                     fxLayoutAlign="center center center">{{calculateCompleted(reportAffirmation)}}</div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                    <mat-icon [ngStyle]="{'color': 'green'}">stop</mat-icon>&nbsp;Συμπλήρωσαν
                </div>
            </div>
            <div fxLayout="column" fxFlex="15">
                <div fxLayout="row" fxLayoutAlign="center center center">{{calculateCanceled(reportAffirmation)}}</div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                    <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Ακύρωσαν
                </div>
            </div>
            <div fxLayout="column" fxFlex="15">
                <div fxLayout="row" fxLayoutAlign="center center center">{{calculatePending(reportAffirmation)}}</div>
                <div fxLayout="row" fxLayoutAlign="center center center">
                    <mat-icon [ngStyle]="{'color': 'orange'}">stop</mat-icon>&nbsp;Δεν απάντησαν
                </div>
            </div>


            <div fxLayout="column" fxFlex="5">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button [ngStyle]="{'background': 'transparent', 'color':'black'}"
                                style="font-family: 'Century Gothic', sans-serif !important;">
                            <mat-icon style="vertical-align: middle; color:var(--haeforangePrimary);">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>

                        <button mat-icon-button>
                            <mat-icon style="vertical-align: middle;">
                                more_vert
                            </mat-icon>
                        </button>

                    </div>
                </div>

                <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="navigateToDetails(reportAffirmation)">
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προβολή λεπτομερειών
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList">
                            <button mat-menu-item (click)="notifyUsers(reportAffirmation)">
                                <mat-icon class="icon">send</mat-icon>&nbsp;Αποστολή ενημέρωσης
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-menu>
            </div>
        </div>

        <div *ngIf="isLoading" fxFlex fxLayoutAlign="center center center" style="margin-top:50px; !important;">
                <app-loading></app-loading>
        </div>

        <div *ngIf="reports.length === 0 && !isLoading">
            <div style="margin-top: 50px; margin-bottom: 50px; font-family: 'Century Gothic', sans-serif;">
                Δεν υπάρχουν αναφορές για δηλώσεις εγγραφών
            </div>
        </div>
    </div>
</div>
